/** Measure performance? */
const enabled = true

export type Mark = 'init' | 'variables' | 'cache' | 'idle' | 'packed'

type PerformanceMetric = {
  name: string
  from: Mark
  to: Mark
}

const metric = {
  initToCache: {
    name: 'Kaltstart bis Eingang der API Daten (Init → Cache)',
    from: 'init',
    to: 'cache',
  },

  variablesToCache: {
    name: 'Dauer der API Abfrage (Variables → Cache)',
    from: 'variables',
    to: 'cache',
  },

  initToIdle: {
    name: 'Kaltstart bis idle frame (Init → Idle)',
    from: 'init',
    to: 'idle',
  },

  cacheToIdle: {
    name: 'Eingang der API Daten idle frame (Cache → Idle)',
    from: 'cache',
    to: 'idle',
  },

  initToPacked: {
    name: 'Kaltstart bis Packing abgeschlossen (Init → Packed)',
    from: 'init',
    to: 'packed',
  },

  cacheToPacked: {
    name: 'Eingang der API Daten bis Packing abgeschlossen (Cache → Packed)',
    from: 'cache',
    to: 'packed',
  },
} as const satisfies Record<string, PerformanceMetric>

export type MetricName = keyof typeof metric

export default {
  enabled,
  metric,
}
